<template>
  <div class="dia-child">
    <el-tabs v-model="activeName3" stretch class="tabs-2" @tab-click="brandTabClick">
      <el-tab-pane label="商标申请进度" name="tab1"></el-tab-pane>
      <el-tab-pane label="商标基础信息" name="tab2"></el-tab-pane>
      <el-tab-pane label="商标流程状态" name="tab3"></el-tab-pane>
      <el-tab-pane label="商标公告" name="tab4"></el-tab-pane>
    </el-tabs>
    <div style="height: 660px;overflow: auto;padding: 0px 20px 50px;" class="el-dialogs">
      <div class="small-title" ref="apply" style="padding-top: 10px;">商标申请进度</div>
      <el-row>
        <el-col :span="24" class="col-2" id="steps_1" style="min-height: 60px;">
          <el-steps space="50%" align-center>
            <el-step v-for="(apply, index) in applyPlannedSpeed.activities" :title="apply.timestamp"
                     :status="apply.status" :description="apply.content"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <div class="small-title" ref="basics">商标基础信息</div>
      <div class="small-tips">基本信息</div>
      <el-descriptions :column="1" border>
        <el-descriptions-item>
          <template slot="label">商标图案</template>
          <el-avatar shape="square" style="width: auto;" fit="scale-down" :src="brandDetails.icon"></el-avatar>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="2" border>
        <el-descriptions-item>
          <template slot="label">商标名称</template>
          {{ brandDetails.name || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">国际分类</template>
          {{ brandDetails.internationalType || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请/注册号</template>
          {{ brandDetails.regNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">商标状态</template>
          {{ brandDetails.status || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">是否共有商标</template>
          {{ brandDetails.isShare || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">商标类型</template>
          {{ brandDetails.trademarkType || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">优先权日期</template>
          {{ brandDetails.firstTime || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">商标形式</template>
          {{ brandDetails.trademarkForm || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">国标注册日期</template>
          {{ brandDetails.regTime || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">后期指定日期</template>
          {{ brandDetails.appointTime || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">类似群</template>
          -
        </el-descriptions-item>
      </el-descriptions>
      <div class="small-tips">法律节点</div>
      <el-descriptions :column="2" border>
        <el-descriptions-item>
          <template slot="label">商标申请日期</template>
          {{ brandDetails.applicationDate || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">专用权期限</template>
          {{ brandDetails.term || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">初审公告期号</template>
          {{ brandDetails.issueNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">初审公告日期</template>
          {{ brandDetails.announcementDate || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">注册公告期号</template>
          {{ brandDetails.regIssueNumber || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">注册公告日期</template>
          {{ brandDetails.regAnnouncementDate || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="small-tips">法律主体</div>
      <el-descriptions :column="2" border>
        <el-descriptions-item>
          <template slot="label">申请人名称(中文)</template>
          {{ brandDetails.applicantChineseName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请人名称(英文)</template>
          {{ brandDetails.applicantEnglishName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请人地址(中文)</template>
          {{ brandDetails.applicantChineseAddress || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">申请人地址(英文)</template>
          {{ brandDetails.applicantEnglishAddress || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">代理/办理机构</template>
          {{ brandDetails.agentMechanism || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="small-title" ref="flow">商标流程状态</div>
      <el-row>
        <el-col :span="24" class="col-2" id="steps_2" style="min-height: 60px;" v-if="brandDetails.trademarkProcess">
          <el-steps :active="brandDetails.trademarkProcess.length" space="70px" align-center direction="vertical">
            <el-step v-for="flow in brandDetails.trademarkProcess" :title="flow.liuchengdate"
                     :description="flow.stepname"></el-step>
          </el-steps>
        </el-col>
      </el-row>
      <div class="small-title" ref="notice">商标公告</div>
      <el-row>
        <el-col :span="24" class="col-2" style="line-height: 30px;min-height: 60px;">
          <div v-for="notice in brandDetails.trademarkGazette">
            <el-link type="primary" @click="seePDF(notice.url)">{{ notice.title }}</el-link>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--PDF文件预览-->
    <el-dialog title="预览" :visible.sync="dialogPriviewPdf" top="0px" width="100%">
      <div :style="'height:'+dialogHeight+'px;'">
        <iframe style="width: 100%;height: 100%" :src="pdfSrc" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "trademarkDetails",
  data(){
    return {
      activeName3: 'tab1',
      dialogPriviewPdf: false,
      pdfSrc: '',
      dialogHeight:document.documentElement.clientHeight - 130,
    }
  },
  props:{
    applyPlannedSpeed: {
      type: Object,
      default() {
        return {}
      }
    },
    brandDetails: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods:{
    brandTabClick(tab, event) {
      if (tab.name == 'tab1') {
        this.$refs.apply.scrollIntoView({block: 'start', behavior: 'smooth'})
      } else if (tab.name == 'tab2') {
        this.$refs.basics.scrollIntoView({block: 'start', behavior: 'smooth'})
      } else if (tab.name == 'tab3') {
        this.$refs.flow.scrollIntoView({block: 'start', behavior: 'smooth'})
      } else if (tab.name == 'tab4') {
        this.$refs.notice.scrollIntoView({block: 'start', behavior: 'smooth'})
      }
    },
    /*PDF文件预览*/
    seePDF(url) {
      if (url != '' && url != null && url != undefined) {
        this.pdfSrc = url;
        this.dialogPriviewPdf = true;
      } else {
        this.$message({message: '暂无展现数据！', type: 'warning'});
      }
    },
  }
}
</script>

<style scoped lang="scss">
.dia-child{
  .el-dialogs{
    .dialog-tab{
      table-layout: fixed;
      border-collapse: separate;
      box-sizing: border-box;
      text-indent: initial;
      border-spacing: 0px;
      border-color: grey;
      tr {
        border-spacing: 0px;
      }
      .col-td1 {
        background: #D6E9FF;
        padding: 15px 10px 15px 20px;
        text-align: left;
        color: #333333;
        border: 0.5px solid #E5EEF6;
        width: 10%;
        border-spacing: 0px;
      }
      .col-td2 {
        padding: 15px 10px;
        background: #ffffff;
        text-align: left;
        width: 20%;
        border-spacing: 0px;
        border: 0.5px solid #E5EEF6;
        word-wrap: break-word;
      }
    }
  }
  .el-dialogs::-webkit-scrollbar {
    width: 8px;
  }
  .el-dialogs::-webkit-scrollbar-thumb {
    background-color: #DDDDDD;
  }
  .tabs-2 {
    .el-tabs--border-card {
      .el-tabs__header {
        .el-tabs__item {
          transition: all .3s cubic-bezier(.645, .045, .355, 1);
          border: none;
          margin-top: -1px;
          color: #333333;
        }
      }
    }
  }
  .small-title {
    font-size: 16px;
    color: #333333;
    text-align: left;
    padding: 30px 0px 10px;
    font-weight: 500;
  }
  .el-dialog {
    margin: 0 auto 0px;
  }
  .col-2 {
    padding: 15px 10px;
    background: #ffffff;
    border: 1px solid #E5EEF6;
    text-align: left;
  }
}
</style>
<style scoped>
.dia-child >>> .el-tabs__header {
  margin: 0 0 0px;
}
.el-dialog >>> .el-dialog__body {
  padding: 20px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.dia-child >>> .el-descriptions-item__label.is-bordered-label {
  color: #333333;
  background: #D6E9FF;
  width: 180px;
}
.dia-child >>> .el-descriptions .is-bordered .el-descriptions-item__cell {
  border: 1px solid #D0E0F2;
  padding: 12px 10px;
  font-size: 14px;
  color: #333333;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
}
.dia-child >>> .el-descriptions__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.dia-child >>> .el-descriptions-item__content {
  min-width: 305px;
}
</style>